<app-type-adresse-complete-obligatoire id="step1" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[organisme]="divers.organisme" [formName]="formName">
</app-type-adresse-complete-obligatoire>